import React from 'react';
import PropTypes from 'prop-types';
import './custom_loading.css';

function CustomLoading({ full_loader: fullLoader, size = 'default' }) {
  const loadingClass = fullLoader ? 'custom-loading-full' : '';
  let sizeClass = '';
  if (size === 'small') {
    sizeClass = 'spinner-small';
  } else if (size === 'large') {
    sizeClass = 'spinner-large';
  }
  return (
    <div className={`custom-loading ${loadingClass}`}>
      <div className={`custom-loading-spinner ${sizeClass}`} />
    </div>
  );
}

CustomLoading.propTypes = {
  full_loader: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'default', 'large'])
};

CustomLoading.defaultProps = {
  full_loader: false,
  size: 'default'
};

export default CustomLoading;
